import React from 'react';
import { CalendarIcon } from '@fourthwall/icons';
import { AnalyticsSelectTool } from '../AnalyticsSelectTool/AnalyticsSelectTool';
import { DateRangeOptions } from './components/DateRangeOptions/DateRangeOptions';
import { getValueLabel } from './utils/getValueLabel';
export const AnalyticsDateRangeSelect = ({ value, options, onSelect, }) => {
    const handleSelect = (value) => {
        onSelect(value);
    };
    return (React.createElement(AnalyticsSelectTool, { label: getValueLabel(value), icon: CalendarIcon, renderContent: ({ close }) => (React.createElement(DateRangeOptions, { value: value, options: options, onSelect: handleSelect, onClose: close })) }));
};
